<template>
  <div class="overlap-modal">
    <CustomModal
      @close="$emit('close')"
      :title="'Overlapping rental'"
      :cancelButtonText="'Cancel'"
      :showOkButton="false"
      :width="'375px'"
    >
      <div slot="body">
        <div style="text-align: left">
          <span>
            There is an overlap between these two rentals. <br />
            Please check and correct the corresponding dates:
          </span>
        </div>
        <div>
          <div class="overlap-detail-wrapper">
            <table class="overlap-table">
              <tr
                v-for="(overlap, index) in overlapData"
                :key="'overlap-table_' + index"
              >
                <td>
                  <img
                    @click="showEditModal(overlap)"
                    class="image"
                    src="../../../assets/editGreen.svg"
                  />
                </td>
                <td>
                  <span>{{ overlap.housemate.name }}</span>
                </td>
                <td>
                  <span>{{ getOverlappingDate(overlap) }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </CustomModal>
  </div>
</template>
<script>
import CustomModal from '@/components/shared/modal/CustomModal.vue'
import calls from '@/api/calls'
export default {
  props: {
    overlapData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    CustomModal
  },
  methods: {
    async showEditModal(overlap) {
      const { data } = await calls.GET('rooms', overlap.room.uuid)
      let section1 = data.room ? { ...data.room } : { ...data }
      let section2 = {
        arrival: overlap.start.format('YYYY-MM-DD HH:mm:ss'),
        arrivalOriginal: overlap.start,
        canceled: overlap.canceled,
        channel: overlap.channel,
        confirmationCode: overlap.confirmationCode,
        departure: overlap.end.format('YYYY-MM-DD HH:mm:ss'),
        departureOriginal: overlap.end,
        houseCode: overlap.houseCode
      }
      let section3 = {
        ...overlap.housemate
      }

      let item = [null, section1, section2, section3]
      this.$emit('close')
      this.$emit('showEditModal', item)
    },
    getOverlappingDate(overlap) {
      return `${overlap.start.format('MMM DD, YYYY')} - ${overlap.end.format(
        'MMM DD, YYYY'
      )}`
    }
  }
}
</script>
<style>
.overlap-modal .modal-container {
  font-size: 13px;
  z-index: 100;
}

.overlap-modal .overlap-table .image {
  width: 15px;
  background: #ebf0e6;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
}

.overlap-modal .overlap-table {
  width: 116%;
  margin-left: -8%;
}

.overlap-modal .modal-cancel-button {
  margin-right: 3px;
}

.overlap-modal .overlap-table,
tr,
td {
  padding-left: 8%;
  border: 0.5px solid #d8dee4;
  border-collapse: collapse;
  border-left: none;
  border-right: none;
  height: 40px;
}

.overlap-modal .overlap-detail-wrapper {
  margin-top: 24px;
}
</style>
